<template>
  <v-chip
    @click.stop.prevent="buttonHandler"
    :class="`${isActive ? 'bg-white border-success' : 'bg-white border-error text-decoration-line-through'}
    ${btnSize === 'medium' ? 'py-2 px-2' : ''}
    ${btnSize === 'large' ? 'py-2.5 px-2' : ''}
    ${btnSize === 'small' ? 'py-1.5 px-2' : ''}
    `"
    class=" m-1
      text-sm
      border
      hover:text-primary
      text-text1
      rounded-xl
      filter_list_btn
      bottom_space
      cursor-pointer
    "
  >
    <span v-if="isActive" class="text-success">{{ btnText }}</span>
    <span v-if="!isActive" class="text-error">{{ btnText }}</span>
  </v-chip>
</template>
<script>
export default {
  props: ["btnText", "selected", "lastInlist", "size"],
  data() {
    return {
      isActive: false,
      btnSize: 'medium',
      screenWidth: 0,
    };
  },
  watch: {
    selected: {
      handler() {
        if (this.selected) {
          this.isActive = this.selected;
        } else {
          this.isActive = this.selected;
        }
      },
    },
  },
   created() {
    window.addEventListener("resize", this.resizeWindowHandler);
  },
  mounted() {
    if (window.innerWidth < 640) {
        this.btnSize = 'small'
      }
    if (this.selected) {
      this.isActive = this.selected;
    }
    if (this.size === 'medium') {
      this.btnSize = 'medium'
    }
    if (this.size === 'small') {
      this.btnSize = 'small'
    }
    if (this.size === 'large') {
      this.btnSize = 'large'
    }
  },
  methods: {
    resizeWindowHandler() {
      this.screenWidth = window.innerWidth
      if (window.innerWidth < 640) {
        this.btnSize = 'small'
      }
    },
    buttonHandler() {
      this.$emit("buttonAction");
    },
  },
};
</script>
<style scoped>
.filter_list_btn {
  min-width: 77px !important;
}
.text-decoration-line-through {
  color: #ff0000;
   text-decoration-line:  line-through !important;
}
</style>

